"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = require("styled-components");
var theme_1 = __importStar(require("@nef/theme"));
require("@nef/theme/lib/fonts/rubik-v8-latin/css/all.css");
require("@nef/theme/lib/fonts/roboto-v20-latin/css/all.css");
require("@nef/theme/lib/fonts/fontawesome-5.9.0/css/all.css");
var globalStyle_1 = __importDefault(require("../globalStyle"));
var themeSelector = function (mode) {
    switch (mode) {
        case "dark":
            return theme_1.darkTheme;
        case "lightWithDarkSidebar":
            return __assign(__assign({}, theme_1.default), { sidebarColors: theme_1.darkTheme.sidebarColors });
        case "light":
        default:
            return theme_1.default;
    }
};
if (process.env.NODE_ENV !== "test") {
    document.body.style.opacity = "0";
}
if (document.fonts) {
    document.fonts.ready.then(function () {
        document.body.style.opacity = "";
    });
}
else {
    document.body.style.opacity = "";
}
var NEFThemeProvider = function (_a) {
    var customTheme = _a.customTheme, children = _a.children, mode = _a.mode, rtl = _a.rtl;
    var nefTheme = react_1.default.useMemo(function () { return (__assign(__assign(__assign({}, themeSelector(mode)), customTheme), { mode: mode,
        rtl: rtl })); }, [mode, rtl]);
    return (react_1.default.createElement(styled_components_1.ThemeProvider, { theme: nefTheme },
        react_1.default.createElement(globalStyle_1.default, null),
        children));
};
NEFThemeProvider.defaultProps = {
    mode: "light"
};
exports.default = NEFThemeProvider;
//# sourceMappingURL=index.js.map